import { motion } from "framer-motion";
import { MapPin, Phone, AtSign } from "lucide-react";
import { LabButton } from "./LabButton";
import { CONTACT } from "../data/site";
import { revealUp, staggerParent, viewportOnce } from "../lib/motion";

const Row = ({ icon: Icon, label, value }) => (
  <motion.div variants={revealUp} className="flex items-start gap-4 border-t border-white/10 py-5">
    <Icon className="mt-0.5 h-5 w-5 shrink-0 text-labyellow" strokeWidth={2} />
    <div>
      <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-labyellow">{label}</p>
      <p className="mt-1 font-body text-base text-offwhite">{value}</p>
    </div>
  </motion.div>
);

export const FindLab = () => {
  const mapSrc = `https://www.google.com/maps?q=${encodeURIComponent(CONTACT.mapsQuery)}&output=embed`;
  const directions = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(CONTACT.mapsQuery)}`;

  return (
    <section data-testid="find-lab-section" className="bg-charcoal">
      <div className="mx-auto grid max-w-[1600px] grid-cols-1 md:grid-cols-2">
        {/* Map */}
        <div className="map-dark relative h-[360px] md:h-auto md:min-h-[600px]">
          <iframe
            title="Chicken Labb location"
            src={mapSrc}
            className="h-full w-full border-0"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            data-testid="location-map"
          />
        </div>

        {/* Contact */}
        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
          variants={staggerParent}
          className="flex flex-col justify-center px-5 py-16 sm:px-14 sm:py-24"
        >
          <motion.p variants={revealUp} className="mb-4 font-mono text-xs uppercase tracking-[0.3em] text-labyellow">
            05 / LOCATION
          </motion.p>
          <motion.h2
            variants={revealUp}
            className="font-display text-3xl leading-[1.08] tracking-tight text-offwhite sm:text-5xl"
          >
            COME TASTE THE <span className="text-labyellow">RESULT.</span>
          </motion.h2>

          <div className="mt-10">
            <Row icon={MapPin} label="Address" value={CONTACT.address} />
            <Row icon={Phone} label="Phone" value={CONTACT.phone} />
            <Row icon={AtSign} label="Social" value={CONTACT.social} />
          </div>

          <motion.div variants={revealUp} className="mt-10">
            <LabButton href={directions} variant="red" testId="get-directions-button">
              Get Directions
            </LabButton>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};
